// ======================================================================
// File Name       : EnterpriseNoticeRegisterEditForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import SelectBox from '../../components/SelectBox';
import FileUpload from '../../components/FileUpload';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { USE_DATE_RELEASE } from '../../constants/EnterpriseNoticeConstants';
import { onChangeWrapper } from '../../utils/FormUtils';
import { VALIDATE_TYPE } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';
import RenderField from '../../utils/ReduxFormUtils';
import PaginationCustom from '../Pagination';
import Dummy from '../../images/dummy.png';

class EnterpriseNoticeRegisterEditForm extends React.Component {

  render() {
    const {
        noticeTitle,
        noticeContent,
        releasePeriod,
        releaseTargetForEnterprise,
        isEdit,
        publicDateFrom,
        publicDateTo,
        radioChange,
    } = this.props;
    const validates = [];
    return (
      <div>
        <Form.Group className="form-info padding-right-15">
          <Col as={Form.Label} sm={4}>
            タイトル<span className="required">&nbsp;(※)</span>
          </Col>
          <Col sm={8}>
            <RenderField
              type="text"
              name="noticeTitle"
              label="タイトル"
              value={noticeTitle}
              validates={[VALIDATE_TYPE.REQUIRED]}
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info label-middle padding-right-15 margin-bottom-8">
          <Col as={Form.Label} sm={4}>
            お知らせ内容<span className="required">&nbsp;(※)</span>
          </Col>
          <Col sm={8}>
            <RenderField
              type="textarea"
              name="noticeContent"
              label="お知らせ内容"
              value={noticeContent}
              className="break-text breakDot"
              validates={[VALIDATE_TYPE.REQUIRED]}
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info padding-right-15">
          <Col as={Form.Label} sm={4}>
             公開期間
            </Col>
          <Col sm={8} className="padding-top-10">
            <RenderField
              type="radio"
              className="padding-top-clear"
              name="releasePeriod"
              value={USE_DATE_RELEASE.INDEFINITE_PERIOD}
              label="無期限"
              normalizeRadio
              checkRadioChange
              radioChange={radioChange}
            />
            <RenderField
              type="radio"
              className="padding-top-clear margin-left-20"
              name="releasePeriod"
              value={USE_DATE_RELEASE.RELEASE_DATE}
              label="公開日指定"
              normalizeRadio
              checkRadioChange
              radioChange={radioChange}
            />
          </Col>
          {releasePeriod === USE_DATE_RELEASE.RELEASE_DATE && <Col sm={12} className="margin-top-20" style={{ marginLeft: '-5px' }}>
            <Col as={Form.Label} sm={4} />
            <Col sm={3}>
              <RenderField
                type="datetime"
                name="publicDateFrom"
                validates={[VALIDATE_TYPE.DATE_TIME]}
                normalizeDateTime
              />
            </Col>
            <Col sm={1} className="text-center" as={Form.Label}>
                ～
            </Col>
            <Col sm={3}>
              <RenderField
                type="datetime"
                name="publicDateTo"
                validates={[VALIDATE_TYPE.DATE_TIME]}
                normalizeDateTime
              />
            </Col>
            <Col sm={12}>
              <Col as={Form.Label} sm={4} />
              <Col as={Form.Label} sm={8}>
                <RenderField
                  name="dateTimeMinMax"
                  type="dateTimeMinMax"
                  validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                  keyDateFrom={'publicDateFrom'}
                  keyDateTo={'publicDateTo'}
                />
              </Col>
            </Col>
          </Col>
          }
        </Form.Group>
        <Form.Group className="form-info padding-right-15">
          <Col as={Form.Label} sm={4}>
                公開範囲
            </Col>
          <Col sm={8}>
            <RenderField
              type="selectbox"
              name="releaseTargetForEnterprise"
              label="公開範囲"
              value={releaseTargetForEnterprise}
              data={SELECT_BOX_DATA.RELEASE_TARGET}
              validates={[VALIDATE_TYPE.REQUIRED_SELECTBOX_NOTICE]}
              normalizeSelectBox
            />
          </Col>
        </Form.Group>
      </div>
    );
  }
}

export default EnterpriseNoticeRegisterEditForm;
